import React from 'react';
import WindowWrapper from '../context/WindowWrapper';

const LoadingWindow = ({ style, close, className, content, ...props }) => {
  return (
    <>
      <WindowWrapper
        maxWidth={600}
        maxHeight={600}
        className={'window-wrapper nice-scroll ' + (className || '')}
        style={style}
        close={close}
      >
        {content}
      </WindowWrapper>
    </>
  );
};

export default LoadingWindow;
